import React from 'react'
import { arrayOf, string } from 'prop-types'
import { chunk } from 'lodash'
import { Grid, Paragraph } from '@cobalt/cobalt-react-components'
import addSeparator from '../../utils/strings/addSeparator'

const renderListElement = element => (
  <Grid.Column key={element} alignCenter all="33" medium="33" small="33">
    <Paragraph forceLineBreak>{addSeparator(element, 3, ' ')}</Paragraph>
  </Grid.Column>
)

const renderRow = (row, index) => (
  <Grid.Group
    key={index}
    horizontalGutters={Grid.Group.HALF_HORIZONTAL_GUTTERS}
  >
    {row.map(element => {
      return renderListElement(element)
    })}
  </Grid.Group>
)

const RecoveryOTPList = props => (
  <Grid noPadding>
    {chunk(props.otpList, 3).map((row, index) => {
      return renderRow(row, index)
    })}
  </Grid>
)

RecoveryOTPList.propTypes = {
  otpList: arrayOf(string)
}

export default RecoveryOTPList
